import styled from 'styled-components';

import { basic } from '../../theme/colors';

// .hdn-link equivalent, will slowly transform into Styled Components for new code

export const A = styled.a<{ inline?: boolean }>`
  border: none;
  font-weight: 400;
  color: ${basic.haydenAccent};
  background: transparent;
  cursor: pointer;
  ${(props) => (props.inline ?
    '' : `
    font-size: 16px;
    line-height: 24px;
  `)}
`;
